import { Outlet, Navigate } from 'react-router'
import Spinner from '@cloudscape-design/components/spinner'
import Box from '@cloudscape-design/components/box'
import { useAuthStore } from '@/state/authStore'

export default function AuthGuard() {
  const status = useAuthStore((s) => s.status)

  if (status === 'loading') {
    return (
      <Box textAlign="center" padding="xxl">
        <Spinner size="large" />
      </Box>
    )
  }

  if (status === 'active') {
    return <Outlet />
  }

  if (status === 'pending' || status === 'suspended') {
    return <Navigate to="/status" replace />
  }

  return <Navigate to="/auth" replace />
}
